const $state = {
	overlayVisible: false,
	overlayFormTheme: null,
	mobileMenuVisible: false,
	baseURL: process.env.NODE_ENV === 'production'
		? window.location.origin
		: 'http://192.168.6.81',
	toasts: [],
	toastIntervalId: null,
};

let count = 0;

function getUniqCount() {
	count += 1;
	return count;
}

const $getters = {
	overlayVisible: state => typeof state.overlayFormTheme === 'string',
	overlayFormTheme: state => state.overlayFormTheme,
	mobileMenuVisible: state => state.mobileMenuVisible,
	baseURL: state => state.baseURL,
	getToasts: state => state.toasts,
	getToastIntervalId: state => state.toastIntervalId,
};

const $mutations = {
	setOverlayFormTheme(state, payload) {
		state.overlayFormTheme = ['no-categories', 'get-catalog', 'make-order', 'make-recall'].includes(payload)
			? payload
			: null;
	},
	setOverlayVisible(state, payload) {
		state.overlayVisible = typeof payload === 'boolean' ? payload : !!payload;
	},
	setMobileMenuVisible(state, payload) {
		state.mobileMenuVisible = typeof payload === 'boolean' ? payload : !!payload;
	},
	setToasts(state, payload) {
		state.toasts = Array.isArray(payload) ? payload : [];
	},
	setToastsIntervalId(state, payload) {
		state.toastIntervalId = payload || null;
	},
};

const $actions = {
	toggleGlobalOverlay({ commit }, payload) {
		return new Promise(resolve => {
			commit('setOverlayVisible', payload);
			resolve();
		});
	},
	toggleOverlayForm({ commit }, payload) {
		return new Promise(resolve => {
			commit('setOverlayFormTheme', payload);
			resolve();
		});
	},

	toggleMobileMenu({ commit }, payload) {
		return new Promise(resolve => {
			commit('setMobileMenuVisible', payload);
			resolve();
		});
	},
	addToast({
		commit,
		dispatch,
		getters,
	}, payload) {
		let intervalId = getters.getToastIntervalId;
		const {
			type,
			name,
		} = payload || {};
		const toasts = [...getters.getToasts];
		toasts.push({
			type,
			name,
			id: getUniqCount(),
		});
		commit('setToasts', toasts);

		if (intervalId === null) {
			intervalId = setInterval(() => {
				const intervalToasts = getters.getToasts;
				if (intervalToasts.length > 0) {
					dispatch('removeToast', intervalToasts[0].id);
				} else {
					clearInterval(intervalId);
					commit('setToastsIntervalId', null);
				}
			}, 4000);

			commit('setToastsIntervalId', intervalId);
		}
	},
	removeToast({
		commit,
		getters,
	}, payload) {
		const toasts = [...getters.getToasts];
		if (toasts.length > 0) {
			const index = toasts.findIndex(item => item.id === payload);

			if (index > -1) {
				toasts.splice(index, 1);
				commit('setToasts', toasts);

				const intervalId = getters.getToastIntervalId;
				if (toasts.length === 0 && intervalId !== null) {
					clearInterval(intervalId);
					commit('setToastsIntervalId', null);
				}
			}
		}
	},
};

export default {
	namespaced: true,
	state: $state,
	getters: $getters,
	mutations: $mutations,
	actions: $actions,
};
